import React, { useState } from 'react';

import AiCommonModal from './AiCommonModal';
import AiQuestionSelection, { type IAiQuestionOption } from './AiCommonModal/AiQuestionSelection';

export type ShipmentServiceLevel = 'standard' | 'expedited' | 'express';

const OPTIONS: IAiQuestionOption[] = [
    { id: 'standard', title: 'Standard' },
    { id: 'expedited', title: 'Expedited' },
    { id: 'express', title: 'Express' },
];

interface IProps {
    step: number;
    totalSteps: number;
    onNext: (value: ShipmentServiceLevel) => void;
    onBack: () => void;
    onClose: () => void;
}

const ServiceLevelSelectionCard = ({ step, totalSteps, onNext, onBack, onClose }: IProps) => {
    const [selected, setSelected] = useState<ShipmentServiceLevel>('standard');

    const handleChange = (ids: (string | number)[]) => {
        const nextId = ids.find((id) => id !== selected);
        if (nextId !== undefined) setSelected(nextId as ShipmentServiceLevel);
    };

    return (
        <AiCommonModal
            title={
                <div className="flex items-center justify-between w-full">
                    <span>What service level is this shipment?</span>
                    <span className="text-gray400 text-xs font-normal">
                        {step}/{totalSteps}
                    </span>
                </div>
            }
            agent="kate"
            handleClose={onClose}
            secondaryBtnText="Back"
            secondaryBtnOnClick={onBack}
            primaryBtnText="Next"
            primaryBtnOnClick={() => onNext(selected)}
        >
            <AiQuestionSelection options={OPTIONS} selectedIds={[selected]} onChange={handleChange} orderedList />
        </AiCommonModal>
    );
};

export default ServiceLevelSelectionCard;
